/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { size } from "lodash";
import speakAPI from "../../libs/api/speak";
import { getQuizId } from "../../SpeechApp";
import { baseUrl } from "../../libs/env";
import { AccountType, assessmentFlow } from "../../components/constants/constants";

export default function SpeakSubmissionStatus(
  isSubmit,
  data,
  setMessage,
  setIsSystemRedirection
) {
  const [items, setItems] = useState({});


  useEffect(() => {
    if (isSubmit && data.user_type === AccountType.STUDENT) {
      if (size(data?.sections_pages) === 0 ) {
        setTimeout(() => {
          getSubmissionStatus();
        }, 1000);
        localStorage.clear();
        setInterval(() => getSubmissionStatus(), 10000);
      }
      else if (data.assessment_flow === assessmentFlow.SEQUENTIAL) {
        setTimeout(() => {
          getSubmissionStatus();
        }, 4000);
        localStorage.clear();
        setInterval(() => getSubmissionStatus(), 10000);
      }
    }
  }, [data, isSubmit]);

  function getSubmissionStatus() {
    speakAPI
      .get_submission_status({ id: getQuizId() })
      .then((res) => res.json())
      .then((json) => {
        if (json.success && json.redirection_url) {
          setIsSystemRedirection(true);
          // window.location.href = `${baseUrl}/${json.redirection_url}`;

          window.location.replace(`${baseUrl}/${json.redirection_url}`);
        } else {
          setItems(json);
        }
      });
  }

  useEffect(() => {
    if (isSubmit && data.user_type === AccountType.STUDENT) {
      setInterval(function () {
        if (items && !items.success) {
          setIsSystemRedirection(true);
          setMessage(
            "Your submission is in a queue, you can access your report later from the homework tab."
          );
          setInterval(() => {
            window.location.replace(
                `${baseUrl}/speak/student/tests/?task_completed=true`);
          }, 10000);
        }
      }, 65000);
    }
  }, [data, isSubmit, items, setMessage,setIsSystemRedirection]);
}
